import { X } from "lucide-react";
import CustomInput from "../../../shared/CustomInput";
import Loading from "../../../shared/Loading";

const EditIncomeDetails = ({
  closeEditIncomeDetails,
  incomeEditDetails,
  setIncomeEditDetails,
  handleEditIncomeDetails,
  loadingEditIncome,
}) => {
  return (
    <div
      onClick={closeEditIncomeDetails}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[880px] h-[580px] overflow-y-auto rounded-[10px] p-[20px] relative bg-white"
      >
        <div
          onClick={closeEditIncomeDetails}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <p className="font-semibold text-[#000000] text-[16px] mb-2">
          Edit Income Details
        </p>
        <p className="text-[15px] font-medium text-[#5C5C5C] mb-4">
          Fill in the income and business-related details below.
        </p>
        <div className="flex flex-col gap-4">
          {/* Row 1 */}
          <div className="flex justify-between gap-4">
            <div className="w-[32%]">
              <label className="text-sm font-medium">Source of Income</label>
              <CustomInput
                placeholder="e.g. Employed, Self-Employed"
                value={incomeEditDetails.sourceOfIncome}
                onChange={(e) =>
                  setIncomeEditDetails({
                    ...incomeEditDetails,
                    sourceOfIncome: e.target.value,
                  })
                }
              />
            </div>
            <div className="w-[32%]">
              <label className="text-sm font-medium">Employer Name</label>
              <CustomInput
                placeholder="e.g. Anansi"
                value={incomeEditDetails.employerName}
                onChange={(e) =>
                  setIncomeEditDetails({
                    ...incomeEditDetails,
                    employerName: e.target.value,
                  })
                }
              />
            </div>
            <div className="w-[32%]">
              <label className="text-sm font-medium">Monthly Income</label>
              <CustomInput
                type="number"
                placeholder="e.g. 10000"
                value={incomeEditDetails.monthlyIncome}
                onChange={(e) =>
                  setIncomeEditDetails({
                    ...incomeEditDetails,
                    monthlyIncome: e.target.value,
                  })
                }
              />
            </div>
          </div>

          {/* Row 2 */}
          <div className="flex justify-between gap-4">
            <div className="w-[32%]">
              <label className="text-sm font-medium">
                Duration at Employer
              </label>
              <CustomInput
                placeholder="e.g. 1-3 years"
                value={incomeEditDetails.durationAtEmployer}
                onChange={(e) =>
                  setIncomeEditDetails({
                    ...incomeEditDetails,
                    durationAtEmployer: e.target.value,
                  })
                }
              />
            </div>
            <div className="w-[32%]">
              <label className="text-sm font-medium">Type of Business</label>
              <CustomInput
                placeholder="e.g. Retail, Farming"
                value={incomeEditDetails.typeOfBusiness}
                onChange={(e) =>
                  setIncomeEditDetails({
                    ...incomeEditDetails,
                    typeOfBusiness: e.target.value,
                  })
                }
              />
            </div>
            <div className="w-[32%]">
              <label className="text-sm font-medium">Years of Operation</label>
              <CustomInput
                placeholder="e.g. 2"
                value={incomeEditDetails.yearsOfOperation}
                onChange={(e) =>
                  setIncomeEditDetails({
                    ...incomeEditDetails,
                    yearsOfOperation: e.target.value,
                  })
                }
              />
            </div>
          </div>

          {/* Row 3 */}
          <div className="flex justify-between gap-4">
            <div className="w-[32%]">
              <label className="text-sm font-medium">Business Ownership</label>
              <CustomInput
                placeholder="e.g. Sole Proprietor"
                value={incomeEditDetails.businessOwnership}
                onChange={(e) =>
                  setIncomeEditDetails({
                    ...incomeEditDetails,
                    businessOwnership: e.target.value,
                  })
                }
              />
            </div>
            <div className="w-[32%]">
              <label className="text-sm font-medium">Business Name</label>
              <CustomInput
                placeholder="Enter business name"
                value={incomeEditDetails.businessName}
                onChange={(e) =>
                  setIncomeEditDetails({
                    ...incomeEditDetails,
                    businessName: e.target.value,
                  })
                }
              />
            </div>
            <div className="w-[32%]">
              <label className="text-sm font-medium">Business KRA Pin</label>
              <CustomInput
                placeholder="Enter KRA pin"
                value={incomeEditDetails.businessKraPin}
                onChange={(e) =>
                  setIncomeEditDetails({
                    ...incomeEditDetails,
                    businessKraPin: e.target.value,
                  })
                }
              />
            </div>
          </div>

          {/* Row 4 */}
          <div className="flex justify-between gap-4">
            <div className="w-[32%]">
              <label className="text-sm font-medium">Business License</label>
              <CustomInput
                placeholder="Enter license details"
                value={incomeEditDetails.businessLicense}
                onChange={(e) =>
                  setIncomeEditDetails({
                    ...incomeEditDetails,
                    businessLicense: e.target.value,
                  })
                }
              />
            </div>
            <div className="w-[32%]">
              <label className="text-sm font-medium">Level of Stability</label>
              <CustomInput
                placeholder="e.g. Stable, Unstable"
                value={incomeEditDetails.levelOfStability}
                onChange={(e) =>
                  setIncomeEditDetails({
                    ...incomeEditDetails,
                    levelOfStability: e.target.value,
                  })
                }
              />
            </div>
            <div className="w-[32%]">
              <label className="text-sm font-medium">Risks Associated</label>
              <CustomInput
                placeholder="e.g. Political, Economic"
                value={incomeEditDetails.risksAssociated}
                onChange={(e) =>
                  setIncomeEditDetails({
                    ...incomeEditDetails,
                    risksAssociated: e.target.value,
                  })
                }
              />
            </div>
          </div>

          {/* Final Row */}
          <div className="w-full">
            <label className="text-sm font-medium">Strength of Business</label>
            <CustomInput
              placeholder="e.g. Reliable customer base"
              value={incomeEditDetails.strengthOfBusiness}
              onChange={(e) =>
                setIncomeEditDetails({
                  ...incomeEditDetails,
                  strengthOfBusiness: e.target.value,
                })
              }
            />
          </div>
        </div>

        <div className="absolute bottom-[20px] right-[20px] flex items-center justify-center gap-[10px]">
          <button
            onClick={closeEditIncomeDetails}
            className="h-[35px] bg-[#F3F3F3] rounded-[30px] px-[15px] text-[#5C5C5C] font-medium"
          >
            Close
          </button>
          <button
            onClick={handleEditIncomeDetails}
            disabled={loadingEditIncome}
            className="h-[35px] bg-[#000000] flex items-center justify-center gap-[5px] rounded-[30px] px-[15px] text-[#FFFFFF] font-medium"
          >
            {loadingEditIncome && <Loading />}
            Edit and Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditIncomeDetails;
